var React = require('react');

function IconX (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.707268 0.292893C0.316744 0.683417 0.316744 1.31658 0.707269 1.70711L10.0002 11L0.494066 20.5061C0.103542 20.8966 0.103542 21.5298 0.494066 21.9203C0.88459 22.3108 1.51776 22.3108 1.90828 21.9203L11.4144 12.4142L20.5063 21.5061C20.8968 21.8966 21.5299 21.8966 21.9205 21.5061C22.311 21.1156 22.311 20.4824 21.9205 20.0919L12.8286 11L21.7073 2.12132C22.0978 1.7308 22.0978 1.09763 21.7073 0.707107C21.3167 0.316582 20.6836 0.316583 20.2931 0.707107L11.4144 9.58579L2.12148 0.292893C1.73096 -0.0976311 1.09779 -0.0976311 0.707268 0.292893Z","fill":"#003B1B"}));
}

IconX.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = IconX;

IconX.default = IconX;
